import React from 'react';
import { motion } from 'framer-motion';
import { HomeIcon, SunIcon, UtensilsIcon, MapPinIcon, UsersIcon, WindIcon } from 'lucide-react';
const items = [{
  Icon: HomeIcon,
  label: 'A shared home that feels like home'
}, {
  Icon: SunIcon,
  label: 'Optional daily experiences'
}, {
  Icon: UtensilsIcon,
  label: 'Shared meals'
}, {
  Icon: MapPinIcon,
  label: 'Local experiences'
}, {
  Icon: UsersIcon,
  label: 'A rotating community'
}, {
  Icon: WindIcon,
  label: 'Space to do your own thing'
}];
export function WhatsIncluded() {
  return <section className="bg-ink text-bone py-24 md:py-32 px-6 md:px-10" data-id="element-121">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-122">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2
      }} className="lg:col-span-7 order-2 lg:order-1 aspect-[4/3] overflow-hidden" data-id="element-123">
          <img src="https://images.unsplash.com/photo-1530653333484-8d038696c1f9?w=1200&q=80&auto=format&fit=crop" alt="Candlelit shared dinner" className="w-full h-full object-cover" data-id="element-124" />
        </motion.div>

        <div className="lg:col-span-5 order-1 lg:order-2" data-id="element-125">
          <p className="eyebrow !text-bone/60 mb-5" data-id="element-126">What's included</p>
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} className="font-serif-display text-3xl md:text-5xl leading-[1.1] text-bone" data-id="element-127">
            Less to plan. <br data-id="element-128" />
            <span className="italic" data-id="element-129">More to feel.</span>
          </motion.h2>

          <ul className="mt-10 divide-y divide-bone/15 border-t border-b border-bone/15" data-id="element-130">
            {items.map((it, i) => <motion.li key={it.label} initial={{
            opacity: 0,
            x: -8
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.06
          }} className="flex items-center gap-4 py-4" data-id="element-131">
                <it.Icon size={18} strokeWidth={1.3} className="text-bone/70 shrink-0" data-id="element-132" />
                <span className="text-bone/85 text-[14px] md:text-[15px]" data-id="element-133">
                  {it.label}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}